import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { shim } from '#utilities/js/ea/submitter.js'
import { close } from '#utilities/js/lightboxes/lightbox.js'
import { formAction, post } from '../../../ea/ajax.js'
import { command } from '../../rte.js'
import { rtes } from './init.js'

const onSubmit = object(listener, {
  type: submit,
  hooks: array([
    preventDefault
  ]),
  task: async (
    form,
    event
  ) => {
    const { dataset, ownerDocument } = form
    const { defaultView } = ownerDocument
    const { FormData } = defaultView
    const { scopeJson } = dataset
    const { loadingImage } = JSON.parse(scopeJson)
    const { contentDocument } = one('iframe', form)
    const rte = rtes.get(contentDocument)
    const { submitter } = shim(event)
    const { name, value } = submitter

    if (rte) {
      const iframe = one('iframe', rte)
      const { contentWindow, id: rteId } = iframe

      queueMicrotask(async () => {
        await contentWindow.focus()

        if (loadingImage) {
          const { value: rValue } = one('[type="hidden"][name="random"]', rte)
          const { value: tValue } = one('[type="hidden"][name="time"]', rte)

          command(rteId, 'InsertImage', loadingImage)

          if (rValue && tValue) {
            const body = new FormData(form)

            for (const img of all('img', contentDocument)) {
              if (img.src && img.src.indexOf(loadingImage) === -1) {
                continue
              }
              if (img.id) {
                continue
              }

              body.set('random', rValue)
              body.set('time', tValue)
              body.set(name, value)
              img.id = 'id_cid_' + tValue + '_' + rValue

              break
            }

            await post(formAction(form, submitter), body, { target: form })

            close()
          }
        }
      })
    }
  }
})

export default form => {
  onSubmit.listen(form)
}
